import { render, staticRenderFns } from "./ContentParagraph.vue?vue&type=template&id=5a3a9ad3&scoped=true&"
import script from "./ContentParagraph.vue?vue&type=script&lang=js&"
export * from "./ContentParagraph.vue?vue&type=script&lang=js&"
import style0 from "./ContentParagraph.vue?vue&type=style&index=0&id=5a3a9ad3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a9ad3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
